/* global DPI_STATS_TMOUT_MS, showModalError */
import React, { useContext, useState, useEffect } from "react";
import ActionsContext from "common/ActionsContext";
import BqnContext from "common/BqnContext";
import Help from "./Help";
import {
  expressLatencyTarget,
  expressDestination,
  parseServiceLatencies,
} from "./api";
import ReportContextControls from "./Controls";
import Request from "common/Request";
import Result from "./Result";
import View from "common/View";
import { getBqnIdCmdPart } from "common/api";


const doLatenciesRetrieval = (
  target,
  hours = 72,
  categories = 10,
  destination = null,
  filter = null,
  mode,
  bqnId
) =>
  expressLatencyTarget(target).then((expressedTarget) =>
    ifCl.run(
      `show statistics dpi latency top hours ${hours} categories ${categories}\
     ${expressedTarget} \
     ${expressDestination(destination)} \
     ${filter === "auto" ? "udrs-auto" : ""}${getBqnIdCmdPart(mode, bqnId)}`,

      { timeout: DPI_STATS_TMOUT_MS }
    )
  );

const retrieval = ({ target, hours, categories, destination, filter, mode, bqnId }) =>
  doLatenciesRetrieval(target, hours, categories, destination, filter, mode, bqnId)
    .then(parseServiceLatencies)
    .then((latencies) => ({ latencies }))
    .catch((error) => showModalError('Something went wrong loading data', error));

const ReportRequest = ({
  hours,
  filter,
  categories,
  destination,
  target,
  retrieval,
  ...rest
}) => {
  const {
    bqnId,
    clusterStatus: { mode },
  } = useContext(BqnContext);
  const [request, setRequest] = useState(null);
  const actions = useContext(ActionsContext);
  const doLoad = () => {
    const doingRetrieval = retrieval({
      hours,
      categories,
      target,
      destination,
      filter,
      mode,
      bqnId
    });
    setRequest(doingRetrieval);
  };
  const context = {
    hours,
    categories,
    target,
    destination,
    filter,
  };
  useEffect(() => {
    doLoad();
    return actions.recv("do-load", doLoad);
  }, [hours, filter, categories, target, destination, bqnId]);
  return request === null ? null : (
    <Request during={request}>
      {(result) => <Result {...result} {...rest} {...context} />}
    </Request>
  );
};

const _defaultContext = {
  hours: 24,
  interval: 10,
  categories: 10,
  filter: "all",
  destination: null,
  target: { subsId: null, addr: null },
};
    
const Report = ({
  provider,
  actions,
  enabled,
  defaultContext = _defaultContext,
  ...rest
}) => {
  const [context, setContext] = useState(defaultContext);
  const updateContext = ({ hours, categories, filter, target, destination }) =>
    setContext((prev) => ({
      ...prev,
      ...(hours === undefined ? {} : { hours }),
      ...(categories === undefined ? {} : { categories }),
      ...(filter === undefined ? {} : { filter }),
      ...(destination === undefined ? {} : { destination }),
      ...(target === undefined ? {} : { target }),
    }));

  return (
    <>
      <ReportContextControls
        enabled={enabled}
        {...context}
        onChange={updateContext}
      >
        <ReportRequest
          {...rest}
          {...context}
          retrieval={provider}
          actions={actions}
        />
      </ReportContextControls>
    </>
  );
};

const DPILatency = ({ returnView = null, ...settings }) => {
  return (
    <View className="container-l g" title="Internet latency per application"
      returnView={returnView}
      Help={Help}>
      <Report
        defaultContext={{ ..._defaultContext, ...settings }}
        provider={retrieval}
        {...settings}
      />
    </View>
  );
};

export default DPILatency;
